import { render } from "./AdDocViewTransactions.vue?vue&type=template&id=24c79d28&ts=true"
import script from "./AdDocViewTransactions.vue?vue&type=script&lang=ts"
export * from "./AdDocViewTransactions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__